import React from "react";
import NotificationAlertOptions from "@/layouts/Alerts";
import { Button, Row, Col, InputGroup, Input, Label, FormGroup } from "reactstrap";

type PropertyDraft = {
  name?: string;
  description?: string;
  type?: string;
  order_listing?: number | string;
  order_product?: number | string;
};

type UpdateOrderViewProps = {
  draft: PropertyDraft;
  onChangeUpdateInput: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onClickUpdate: () => void;
};

export default function UpdateOrderView({
  draft,
  onChangeUpdateInput,
  onClickUpdate,
}: UpdateOrderViewProps) {
  return (
    <>
      <Row>
        <Col>
          {/* order_listing */}
          <FormGroup className="row">
            <Label className="form-control-label" md="2">
              Order_listing
            </Label>
            <Col md="7">
              <InputGroup className="mb-2">
                <Input
                  placeholder="Update Property Order_listing"
                  name="order_listing"
                  type="number"
                  value={draft.order_listing ?? ""}
                  onChange={onChangeUpdateInput}
                />
              </InputGroup>
            </Col>
          </FormGroup>

          {/* order_product */}
          <FormGroup className="row">
            <Label className="form-control-label" md="2">
              order_product
            </Label>
            <Col md="7">
              <InputGroup>
                <Input
                  placeholder="Update Property order_product"
                  name="order_product"
                  type="number"
                  value={draft.order_product ?? ""}
                  onChange={onChangeUpdateInput}
                />
              </InputGroup>
            </Col>
          </FormGroup>
        </Col>
      </Row>

      {/* Update Orders BUTTON */}
      <Col>
        <FormGroup style={{ right: 0, position: "absolute" }} className="row">
          <Button
            className="btn btn-outline-primary mr-1 float-right"
            color="primary"
            type="button"
            onClick={() => {
              onClickUpdate();
              NotificationAlertOptions("success", "Property Updated Successfully");
            }}
          >
            Update Orders Property
          </Button>
        </FormGroup>
      </Col>
    </>
  );
}
